<template>
  <div>
    <nav-bar></nav-bar>
    <div class="container">
      <div class="section">
        <lead class="lead" v-for="(lead, idx) in leads" :key="idx" :lead="lead">
        </lead>
        <div @click="openLeadEntryModal" class="box has-text-centered button add-lead-button">
          <fa-icon icon="plus"></fa-icon>
        </div>
      </div>
      <modal @done="closeLeadEntryModal" :is-active="isModalOpen">
        <lead-entry
          @done="closeLeadEntryModalAndRefresh"
          @cancel="closeLeadEntryModal"
        ></lead-entry>
      </modal>
    </div>
  </div>
</template>

<script>
import Lead from '@/components/Lead.vue';
import Modal from '@/components/Modal.vue';
import LeadEntry from '@/components/LeadEntry.vue';
// import EngagementEntry from '@/components/EngagementEntry.vue'
import { getLeads } from '@/utils/api';

export default {
  name: 'lead-list',
  components: {
    lead: Lead,
    'lead-entry': LeadEntry,
    // 'engagement-entry': EngagementEntry,
    modal: Modal,
  },
  async created() {
    this.leads = await getLeads();
  },
  data() {
    return {
      leads: [],
      isModalOpen: false,
    };
  },
  methods: {
    openLeadEntryModal() {
      this.isModalOpen = true;
    },
    closeLeadEntryModal() {
      this.isModalOpen = false;
    },
    async closeLeadEntryModalAndRefresh() {
      this.leads = await getLeads();
      this.isModalOpen = false;
    },
  },
};
</script>

<style scoped>
.lead {
  margin-top: 2rem;
}

.add-lead-button {
  margin-top: 2rem;
  margin-left: -12px;
  margin-right: -12px;
}


</style>
